import React, { useEffect, useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import {
  replacebuttonStyles,
  replacecommonTextStyles,
  replaceheaderStyles,
  replaceiconStyles,
} from "./replaceHeaderStyle";
import { useDispatch, useSelector } from "react-redux";
import { darkTheme } from "../../../../../../theme/Theme";
import PropTypes from "prop-types";

import {
  setViewSummaryDrawer,
  setSummaryDetails,
  setViewPageName,
} from "../../../../../../slices/viewSummarySlice";
import { getAPI } from "../../../../../../API/ApiService";
import { BASE_URL } from "../../../../../../constant/apiUrl";
import { showErrorToast } from "../../../../../../utils/Toast/toast";
import Loading from "../../../../../../utils/Loader";
export default function ReplaceTableHeader({ content, replaceId }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isDarkTheme = useSelector((state) => state.theme);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const handleViewSummary = () => {
    dispatch(setViewSummaryDrawer(true));
    dispatch(setSummaryDetails(content || data));
    dispatch(setViewPageName("Documents"));
  };

  useEffect(() => {
    if (content === undefined) {
      const fetchData = async () => {
        try {
          const response = await getAPI(
            `${BASE_URL}/content/find-detail-by-id/${replaceId}`
          );
          if (response?.status === 200) {
            setData(response?.data);
          }
        } catch (err) {
          showErrorToast(err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    } else {
      setLoading(false);
    }
  }, [replaceId]);
  if (loading) return <Loading />;
  return (
    <Box
      sx={
        isMobile
          ? {
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: "100%",
              backgroundColor: isDarkTheme
                ? darkTheme.cardBackgroundColorLayer3
                : "#F3F7FD",
            }
          : {
              ...replaceheaderStyles,
              backgroundColor: isDarkTheme
                ? darkTheme.cardBackgroundColorLayer3
                : "#F3F7FD",
            }
      }
    >
      <Box
        sx={{
          flex: "1 0 0",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography
          sx={{
            ...replacecommonTextStyles,
            fontWeight: 700,
            color: isDarkTheme ? "white" : "black",
          }}
        >
          Card item
        </Typography>
        <Typography
          sx={{
            ...replacecommonTextStyles,
            fontWeight: 400,
            color: isDarkTheme ? "white" : "black",
          }}
        >
          {content?.title || data?.title}
        </Typography>
      </Box>
      <Box>
        <Button sx={replacebuttonStyles} onClick={handleViewSummary}>
          <Typography
            sx={{
              ...replacecommonTextStyles,
              color: "var(--Tokens-Button-Borderless, #005CBC)",
              fontWeight: 700,
            }}
          >
            View Summary
          </Typography>
          <RemoveRedEyeOutlinedIcon sx={replaceiconStyles} />
        </Button>
      </Box>
    </Box>
  );
}
ReplaceTableHeader.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string, // `title` is an optional string property in the `content` object
  }).isRequired, // `content` is required and must be an object
};
